// @ts-strict
import {type ReactElement} from 'react';
import {Alert, AlertTitle, Link} from '@ezcater/tapas';
import {Form} from 'formik';
import useTranslation from 'next-translate/useTranslation';

import {PRIVACY_PATH} from '@/paths';
import {Step1ContactAndCategory, Step2CategoryAndMessage} from './steps';
import {useSupportMessageWizard} from './SupportMessageProvider';
import {StepEnum} from './types';

const SupportMessageFields = (): ReactElement => {
  const {t} = useTranslation('common');
  const {step, isSingleStep, submitErrorKey, surface} = useSupportMessageWizard();

  return (
    <Form className="flex flex-col gap-6" data-testid="support-message-form">
      <p className="text-sm text-peppercorn-600">
        {t('components.SupportMessage.intro')}
        {surface !== 'standalone_route' && (
          <>
            {' '}
            <Link
              className="text-sm font-bold"
              href={PRIVACY_PATH}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('components.SupportMessage.privacyPolicy')}
            </Link>
            .
          </>
        )}
      </p>

      {isSingleStep ? (
        // Nested so the two groups keep one uniform field gap rather than the Form's wider one.
        <div className="flex flex-col gap-4">
          <Step1ContactAndCategory />
          <Step2CategoryAndMessage hideCategoryLevel1 />
        </div>
      ) : (
        {
          [StepEnum.ContactAndCategory]: <Step1ContactAndCategory />,
          [StepEnum.CategoryAndMessage]: <Step2CategoryAndMessage />,
        }[step]
      )}

      {submitErrorKey && (
        <Alert variant="critical" data-testid="support-message-submit-error">
          <AlertTitle>{t(submitErrorKey)}</AlertTitle>
        </Alert>
      )}
    </Form>
  );
};

export default SupportMessageFields;
